export default ($timeout, root) => (scope, elem, attrs, ctrl) => {
  elem.on('cut', (e) => {
    // if no timeout, textContent not updated? ¯\_(ツ)_/¯
    // only works for .text, .block_quote, .header, .list in contetemplate service
    $timeout(() => {
      if (e.target.textContent.length === 0) {
        const { index } = e.target.dataset
        const item = scope.story.content_elements[index]
        // cut puts a <br /> in there, dunno why
        const { length } = (item.items
          ? e.target.parentNode
          : e.target
        ).textContent
          .trim()
          .replace(/<br\s?\/>/g, '')
        // for lists, do this anyway
        // the controller will be responsible for determing if we want to remove
        // the entire element, since it has easy access to content_elements obj
        length < 1 && root.$broadcast('DESTROY_ELEM', { index })
      }
    }, 50)
  })

  if (scope.isRevision) {
    $timeout(() => {
      //  ensure that text of previous revisions are not editable (but they are selectable/copy-able)
      elem
        .find('div#story-wrapper [contenteditable=true]')
        .removeAttr('contenteditable')
    }, 0)
  }
}
